import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { UserProvider } from './providers/UserProvider';
import { ShortcutsProvider } from './providers/ShortcutsProvider';
import { App } from './App';
import { LocalReaderPreferences } from './components/LocalReaderPreferences';
import RouteErrorPage from './pages/RouteErrorPage';

const isProd =
  window.location.hostname === 'kingfisher.tldr.fm' ||
  document.documentElement.dataset.env === 'prod';

if (!isProd) {
  const isDev =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  const tag = isDev ? 'DEV' : 'TEST';
  document.body.classList.add('env-nonprod');
  document.body.setAttribute('data-env-tag', tag);
  if (!document.title.startsWith('[')) {
    document.title = `[${tag}] ${document.title}`;
  }
  const iconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (iconLink && !iconLink.href.includes('favicon-test.svg')) {
    iconLink.href = '/assets/favicon-test.svg';
  }
}

// A data router lets editors block history navigation before their drafts unmount.
const router = createBrowserRouter([{
  path: '*',
  element: (
    <UserProvider>
      <LocalReaderPreferences>
        <ShortcutsProvider>
          <App />
        </ShortcutsProvider>
      </LocalReaderPreferences>
    </UserProvider>
  ),
  errorElement: <RouteErrorPage />,
}]);

const root = createRoot(document.getElementById('app')!);
root.render(<RouterProvider router={router} />);

